/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChatExportResponseDto
 */
export interface ChatExportResponseDto {
    /**
     * Export result message
     * @type {string}
     * @memberof ChatExportResponseDto
     */
    message: string;
    /**
     * Export timestamp
     * @type {Date}
     * @memberof ChatExportResponseDto
     */
    exportedAt: Date;
    /**
     * Temporary signed download URL for the exported PDF (expires in 1 hour)
     * @type {string}
     * @memberof ChatExportResponseDto
     */
    fileUrl: string;
    /**
     * File size of the exported PDF
     * @type {object}
     * @memberof ChatExportResponseDto
     */
    fileSize?: object | null;
}

/**
 * Check if a given object implements the ChatExportResponseDto interface.
 */
export function instanceOfChatExportResponseDto(value: object): value is ChatExportResponseDto {
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('exportedAt' in value) || value['exportedAt'] === undefined) return false;
    if (!('fileUrl' in value) || value['fileUrl'] === undefined) return false;
    return true;
}

export function ChatExportResponseDtoFromJSON(json: any): ChatExportResponseDto {
    return ChatExportResponseDtoFromJSONTyped(json, false);
}

export function ChatExportResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatExportResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
        'exportedAt': (new Date(json['exportedAt'])),
        'fileUrl': json['fileUrl'],
        'fileSize': json['fileSize'] == null ? undefined : json['fileSize'],
    };
}

export function ChatExportResponseDtoToJSON(json: any): ChatExportResponseDto {
    return ChatExportResponseDtoToJSONTyped(json, false);
}

export function ChatExportResponseDtoToJSONTyped(value?: ChatExportResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'exportedAt': ((value['exportedAt']).toISOString()),
        'fileUrl': value['fileUrl'],
        'fileSize': value['fileSize'],
    };
}

